import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter, browserHistory } from 'react-router';
import { Row, Col, Progress, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Tooltip, UncontrolledTooltip } from 'reactstrap';
import NumericLabel from 'react-pretty-numbers';
import { EditSidebar, Header, ContractSideBar, ContrSelectField, WidgetCard, WidgetTitle, ContractBarLoader, FieldLabel, ContrInputField, ContrDateField, FieldCol, FieldGroup, FieldDate } from '../../Elements';
import { removeEmptyKey } from '../../../../utils';
import { displayDateFormat, imgStoragePath, assetsType, backendDateFormat, fieldDateFormat } from '../../../../constants';
import { ListLoader, NoRecordFound, InfoIcon } from '../../../../shared';
import { sGlobalConstantAc, sExportContractsAc } from '../../../../shared/actionCreators';
import FilterBar from '../../../../shared/FilterBar';
import InvoiceList from '../components/InvoiceList';
import InvoiceFilter from '../components/InvoiceFilter';
import InvoiceTotal from '../components/InvoiceTotal';
import Pagination from "react-js-pagination";
import ChangeInvoiceStatus from '../components/ChangeInvoiceStatus';
import { InvoiceAssetViewAc, invoiceDatesAc, genInvoiceStrAc, invoiceListAc, exportContractCashflowAc, changeInvoiceStatusAc, deleteInvoiceViewAc, reseverAcntListAc } from '../actionCreators';
import { GEN_INVOICE } from '../actions';
import moment, { months } from 'moment';
import RoleBasedAccess from '../../../../utils/RoleBasedAccess';
import { getLocalStorageInfo, showCurrencyFormat } from '../../../../utils';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import exportIcon from '../../../../shared/assets/img/export_icon.svg';
import { getInvoiceAttachment, getPartyInfo } from '../apiServices'
import { contrHdlineInfoAc } from '../../HeadlinesInfo/actionCreators';
import { titanInstance, gaTelesisInstance, Lessor_test, testLessor } from '../../../../shared_elements/components';
import { Checkbox, FormControl, FormControlLabel, FormLabel, IconButton, Paper, Radio, RadioGroup, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core';
import { DeleteOutlineRounded, RemoveCircleOutline, TodayOutlined } from '@material-ui/icons';
import { TableListComp } from '../../../../shared_elements';
import { Autocomplete } from '@material-ui/lab';
import { globalGetService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { regexConstants } from '../../../../constants/regEx';
import { FieldTextarea } from '../../../technicalInspection/Elements';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import ExcessAmountModal from '../components/ExcessAmountModal';
import { jetStreamInstance } from '../../../../lease_management/Leases';
class Invoice extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      appliedFilter: {},
      page: 1,
      dropdownOpen: false,
      tooltipOpen: false,
      attachedDocList: [],
      partyList: [],
      isIndependent: false,
      reserveRateList: []  ,
      independentInvoiceItem: [{ reference_id: '', invoice_item_name: ''}],
      parentInvoiceType : '',
      remarks:'',
      showExcessModal:{modal:false},
      isLoading:false,
      servicerList:[],
      error:{},
      rentalInvoiceType: { value: 1, label: "Advance" },
    }
    this.getInvoiceAttachment = getInvoiceAttachment.bind(this)
    this.getPartyInfo = getPartyInfo.bind(this)
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  toggleTip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  componentDidMount() {
    this.props.fetchContractInfo();
    this.props.fetchAssetInfo();
    this.props.fetchTechConstant({ constant_types: ['security_deposit_type'] });
    this.getInvoiceAttachment(this.props?.params?.contract_slug ? this.props.params.contract_slug : null);
    if (titanInstance || gaTelesisInstance) {
      this.getPartyInfo(this.props?.params?.contract_slug ? this.props.params.contract_slug : null, titanInstance);
      this.getServicerList()
    }
  }
  fetchReserveAccounts = () => {
  const { contract_slug } = this.props.params;

  globalGetService(`contracts/${contract_slug}/reserve-accounts/`, {})
    .then((response) => {
      if (response?.data?.data) {
        this.setState({ reserveRateList: response.data.data });
      }
    })
    .catch((err) => {
      console.error("Error fetching reserve accounts", err);
      this.setState({ reserveRateList: [] });
    });
};

  getServicerList = () => {
    globalGetService(`console/owner/?dropdown=true`)
      .then(response => {
        this.setState({ servicerList: response.data.data });
      })
  }

  updateListInvStatus = (data, contractSlug, invoiceId, type) => {
    this.props.updateInvStatus(data, contractSlug, invoiceId, type);
  }

  changeMsn = (evt) => {
    let url = '/' + assetsType[evt.asset_type] + '/' + evt.slug + '/contracts';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  checkInvoiceHistory =(contract_slug, invoiceParams, assetViewId, invoiceType,isProRated)=>{
    let payload ={invoice_type:parseFloat(invoiceType)}
    this.setState({isLoading:true})
    globalPostService(`contracts/${contract_slug}/invoice-validate`, payload)
    .then(response=>{
      if(checkApiStatus(response)){
        this.setState({isLoading:false})
        if(response.data.data.show_popup){
          // this.props.updateGenInvoice('flag', false)
          this.setState({showExcessModal:{data:response.data.data, modal:true, props:{contract_slug, invoiceParams, assetViewId,isProRated} }})
        }else{
          this.props.genInvoiceStr(contract_slug, invoiceParams, assetViewId, isProRated);
          this.setState({showExcessModal:{modal:false}})
        }
      }
    })
  }
  onProceed =()=>{
    const {contract_slug, invoiceParams, assetViewId, isProRated} = this.state.showExcessModal.props
    this.props.genInvoiceStr(contract_slug, invoiceParams, assetViewId,isProRated);
    this.setState({showExcessModal:{modal:false}})
  }
  updateForm = (type, value) => {
    if (type === 'parent_invoice_type' && value === '1') {
      this.fetchReserveAccounts();
    } 
    if (type == 'invoiceType' && value !== '6') {
      if (value == 2 && jetStreamInstance){
        this.props.fetchDates(this.props.params.contract_slug, value, this.state.rentalInvoiceType.value, 'rental_invoice_type');
      }else{
        this.props.fetchDates(this.props.params.contract_slug, value);
      }
    } else if (type === 'security_deposit_type') {
      if(value){
        this.props.fetchDates(this.props.params.contract_slug, this.props.genInvoice.invoiceType, value, 'security_deposit_type');
      }else{
        this.props.updateGenInvoice('security_deposit',[])
        this.props.updateGenInvoice('selectedDate','')
      }
    }
    if (type === 'selectedDate' ) {
      this.props.updateGenInvoice('updatedDate', value);
      this.props.updateGenInvoice('is_offset', false);
      if (!this.props.genInvoice?.prorated_months?.includes(value)) {
        this.props.updateGenInvoice('end_month', value);
        this.props.updateGenInvoice('updatedEndDate', moment(value).endOf('month').format(backendDateFormat) );
      }else{
          this.props.updateGenInvoice('updatedDate', value);
          this.props.updateGenInvoice('end_month', null);
          this.props.updateGenInvoice('updatedEndDate', null );
      }
    }
    if (type === 'end_month' ) {
      this.props.updateGenInvoice('updatedEndDate', moment(value).endOf('month').format(backendDateFormat) );
    }
    if (['vat_tax', 'management_tax'].includes(type)) {
      this.setState(prevState => ({ error: { ...prevState.error, [type]: '' } }));
    }
    this.props.updateGenInvoice(type, value);   
  }
  getInvoiceStr = (e) => {
    e.preventDefault();
    const { contract_slug } = this.props.params;
    const { invoiceType, selectedDate, bank_details_id, party_id, jct_invoice, sofr_percentage, management_tax, vat_tax, updatedDate, updatedEndDate, invoice_to_id, servicer_id, is_offset } = this.props.genInvoice;
    const { assetViewId } = this.props;
    if ((invoiceType === '5'||invoiceType === '4') && !this.state.parentInvoiceType && this.state.isIndependent===true) {
      toastFlashMessage('Please select Parent Invoice Type', 'error')
      return;
    }
    const hasReserveSelected = (this.state.independentInvoiceItem || []).some(row => row.reference_id);
    const selectedBank = this.props.genInvoice.dates?.find(d => d.value === selectedDate);
    if ((invoiceType === '5'||invoiceType === '4') && this.state.parentInvoiceType === '1' && !hasReserveSelected && this.state.isIndependent===true) {
      toastFlashMessage('Please add at least one Reserve Rate', 'error')
      return;
    }
    let validateNewInput = {};
    let hasError = false;
    if ((gaTelesisInstance || testLessor) && invoiceType === '10') {
      if (!servicer_id) {
        validateNewInput.servicer_id = 'Please select Servicer';
        hasError = true;
      }
      if (!invoice_to_id) {
        validateNewInput.invoice_to_id = 'Please select Invoiced To';
        hasError = true;
      }
      if (!management_tax) {
        validateNewInput.management_tax = 'Please enter Management Fee %';
        hasError = true;
      }
      // if (!vat_tax) {
      //   validateNewInput.vat_tax = 'Please enter VAT %';
      //   hasError = true;
      // }
      if (hasError) {
        this.setState({ error: validateNewInput });
        return;
      }
    }
    if(!invoiceType){
        validateNewInput.invoiceType = 'Please select Invoice Type';
        hasError = true;
    }
     if (hasError) {
        this.setState({ error: validateNewInput });
        return;
      }
    let invoiceData = {
      invoice_type: invoiceType,
      bank_details_id: this.props.genInvoice?.bank_details?.some(bank => bank?.id === selectedBank?.bank_id) && invoiceType !== '10'?selectedBank?.bank_id:bank_details_id||null,
      // remarks:this.state.remarks?this.state.remarks:'',
    };
    const isSpecialInvoiceType = (invoiceType === '9' || invoiceType === '8' || invoiceType === '7' || invoiceType === '10');
    if(gaTelesisInstance && invoiceType === '2'){
      invoiceData={ ...invoiceData,
        month:updatedDate,
        end_month:updatedEndDate
      }
    }
    const invoiceParams = {
      ...invoiceData,
      ...(isSpecialInvoiceType ? { id: selectedDate } : { month: gaTelesisInstance && invoiceType === '2'? updatedDate :selectedDate }),
      ...((titanInstance || gaTelesisInstance) ? { party_id: party_id } : {}),
      ...((gaTelesisInstance || Lessor_test) ? { jct_invoice: jct_invoice, sofr_percentage:sofr_percentage } : {}),
      ...((gaTelesisInstance || testLessor) && invoiceType === '10' ? { management_tax:management_tax, vat_tax:vat_tax||0, invoice_to_id:invoice_to_id, servicer_id:servicer_id } : {}),
      ...((invoiceType === '5'||invoiceType === '4') && this.state.isIndependent===true && this.state.parentInvoiceType=== '1'  ? { parent_invoice_type : this.state.parentInvoiceType, invoice_items_details: this.state.independentInvoiceItem, } : {}),
      ...((invoiceType === '5'||invoiceType === '4') && this.state.isIndependent===true && this.state.parentInvoiceType=== '2' ? { parent_invoice_type : this.state.parentInvoiceType} : {}),
      ...((invoiceType === '5'||invoiceType === '4') && titanInstance ?{remarks:this.state.remarks?this.state.remarks:'', is_offset: is_offset || false}:{}),
      ...(invoiceType === '2' && jetStreamInstance ? { rental_invoice_type: this.state.rentalInvoiceType } : {}),
    };
    let validate = true

    const {genInvoice} = this.props
    const { dates } = this.props.genInvoice;
    const types = ['1', '2', '10'];
    if (
      !(gaTelesisInstance && invoiceType === '2') &&
      (dates.length > 0 || gaTelesisInstance) &&
      (types.includes(invoiceType) || (['4', '5'].includes(invoiceType) ? !this.state.isIndependent : true)) &&
      !selectedDate
    ) {
      if(gaTelesisInstance && invoiceType =='10'&& dates.length < 1){
        toastFlashMessage(`Couldn’t fetch any rental invoices to Management Fee Invoice`,'error')
      } else{
        toastFlashMessage(`Please select ${genInvoice.invoiceType == '1' ? 'Utilization month to be invoiced' : genInvoice.invoiceType == '2' ? 'Rental month to be invoiced' : 'Invoice number'}`,'error');
      }
      return;
    }
    if(gaTelesisInstance && invoiceType === '2'){
    validate = moment(invoiceParams.end_month).diff(invoiceParams.month) >0 
    if(validate == false){
      toastFlashMessage('End Date cannot be same or less than Start Date', 'error')
    } 
    // if (this.props.genInvoice?.prorated_months?.includes(invoiceParams.month) && !this.props.genInvoice?.prorated_months?.includes(invoiceParams.end_month)) {
    //     toastFlashMessage(`End Date should be within the prorated months: ${this.props.genInvoice.prorated_months.join(', ')}`, 'error');
    //   }
    }
    const invoiceMonth = invoiceType === '2' && invoiceParams?.month  && invoiceParams?.month?.slice(0, 7); 
    const isProrated = this.props.genInvoice?.prorated_months?.some(date => date.slice(0, 7) === invoiceMonth);
    if(invoiceType ==='6' ){
      if(!genInvoice?.security_deposit_type){
      toastFlashMessage('Please select Security Deposit Type', 'error')
      return
      }
      if(!selectedDate && genInvoice?.security_deposit?.length){
        toastFlashMessage('Please select Security Deposit Against ( Amount )', 'error')
        return
      }
    }
    if(validate){
      if(['1','2'].includes(invoiceType )){ 
        this.checkInvoiceHistory(contract_slug, invoiceParams, assetViewId, invoiceType, isProrated)
      } else{
        this.props.genInvoiceStr(contract_slug, invoiceParams, assetViewId);
      }
    }
    // if(titanInstance){
    //   if(this.props.genInvoice.invoiceType ==='9'){
    //     this.props.genInvoiceStr(this.props.params.contract_slug, {invoice_type: this.props.genInvoice.invoiceType,id: this.props.genInvoice.selectedDate, bank_details_id: this.props.genInvoice.bank_details_id,party_id :this.props.genInvoice.party_id}, this.props.assetViewId)
    //   }else if(this.props.genInvoice.invoiceType !== '7' && this.props.genInvoice.invoiceType !== '8'){
    //     this.props.genInvoiceStr(this.props.params.contract_slug, {invoice_type: this.props.genInvoice.invoiceType,month: this.props.genInvoice.selectedDate, bank_details_id: this.props.genInvoice.bank_details_id,party_id :this.props.genInvoice.party_id}, this.props.assetViewId)
    //   }
    //   else{
    //     this.props.genInvoiceStr(this.props.params.contract_slug, {invoice_type: this.props.genInvoice.invoiceType,id: this.props.genInvoice.selectedDate, bank_details_id: this.props.genInvoice.bank_details_id,party_id :this.props.genInvoice.party_id}, this.props.assetViewId)
    //   }
    // }else{
    //   if(this.props.genInvoice.invoiceType ==='9'){
    //     this.props.genInvoiceStr(this.props.params.contract_slug, {invoice_type: this.props.genInvoice.invoiceType,id: this.props.genInvoice.selectedDate, bank_details_id: this.props.genInvoice.bank_details_id}, this.props.assetViewId)
    //   }else if(this.props.genInvoice.invoiceType !== '7' && this.props.genInvoice.invoiceType !== '8'){
    //     this.props.genInvoiceStr(this.props.params.contract_slug, {invoice_type: this.props.genInvoice.invoiceType,month: this.props.genInvoice.selectedDate, bank_details_id: this.props.genInvoice.bank_details_id}, this.props.assetViewId)
    //   }
    //   else{
    //     this.props.genInvoiceStr(this.props.params.contract_slug, {invoice_type: this.props.genInvoice.invoiceType,id: this.props.genInvoice.selectedDate, bank_details_id: this.props.genInvoice.bank_details_id}, this.props.assetViewId)
    //   }
    // }

  }

  clearFilterValue = (label) => {
    let filterParams = Object.assign({}, this.state.appliedFilter);
    delete filterParams[label];
    let getQueryStr = removeEmptyKey(this.getQueryStrfn(filterParams));
    this.props.fetchInvList(this.props.params.contract_slug, getQueryStr);
    this.setState({
      appliedFilter: filterParams,
      selectedFilterTitle: '',
      page: 1
    });
  }

  changeFilterFn = (...args) => {

    let filterParams = Object.assign({}, this.state.appliedFilter);
    switch (args[0]) {
      case 'invoice_type':
        if (args[1]) {
          filterParams = {
            ...filterParams,
            [args[0]]: {
              name: 'Invoice Type ', value: args[1].label,
              filterData: args[1].value
            }
          }
        }
        break;
      case 'status':
        if (args[1]) {
          filterParams = {
            ...filterParams,
            [args[0]]: {
              name: 'Invoice Status ',
              value: args[1].label,
              filterData: args[1].value
            }
          }
        }
        break;
      case 'dueDate':
        filterParams = {
          ...filterParams,
          'dueDate': {
            name: 'Invoice Due Date',
            value: (args[1] ? args[1] : '--') + ' To ' + (args[2] ? args[2] : '--'),
            dueStartDate: args[1] ? args[1] : '',
            dueEndDate: args[2] ? args[2] : ''
          }
        }
        break;
      case 'transactionDate':
        filterParams = {
          ...filterParams,
          'transactionDate': {
            name: 'Invoice Date',
            value: (args[1] ? args[1] : '--') + ' To ' + (args[2] ? args[2] : '--'),
            startDate: args[1] ? args[1] : '',
            endDate: args[2] ? args[2] : ''
          }
        }
        break;
      case 'overdue_days':
        if (args[1]) {
          filterParams = {
            ...filterParams,
            [args[0]]: {
              name: 'Invoice Overdue by Days ', value: args[1],
              filterData: args[1]
            }
          }
        }
        break;
      case 'invoice_number':
        if (args[1]) {
          filterParams = {
            ...filterParams,
            [args[0]]: {
              name: 'Invoice Number ', value: args[1],
              filterData: args[1]
            }
          }
        }
        break;
      case 'currency':
        if (args[1]) {
          filterParams = {
            ...filterParams,
            [args[0]]: {
              name: 'Currency Type ', value: args[1].label,
              filterData: args[1].value
            }
          }
        }
      default:
        break;
    }
    this.setState({
      appliedFilter: filterParams,
      selectedFilterTitle: '',
      page: 1
    });

    let getQueryStr = removeEmptyKey(this.getQueryStrfn(filterParams));
    this.props.fetchInvList(this.props.params.contract_slug, getQueryStr);
  }
  getQueryStrfn = (params) => {
    let queryFilter = {};
    Object.keys(params).map(key => {
      if (key == 'transactionDate') {
        queryFilter['startDate'] = params[key].startDate
        queryFilter['endDate'] = params[key].endDate
      } else if (key == 'dueDate') {
        queryFilter['dueStartDate'] = params[key].dueStartDate
        queryFilter['dueEndDate'] = params[key].dueEndDate
      } else {
        queryFilter[key] = params[key].filterData
      }
    });
    return queryFilter;
  }
  handlePageChange = (page) => {
    let getQueryStr = removeEmptyKey(this.getQueryStrfn(this.state.appliedFilter));
    getQueryStr['page'] = page;
    this.setState(prevState => ({
      ...prevState,
      page: page
    }));
    this.props.fetchInvList(this.props.params.contract_slug, getQueryStr);
  }
  handleItemChange = (index, field, value) => {
    const rows = [...this.state.independentInvoiceItem];
    if (field === 'reserve_object') {
      rows[index]['reference_id'] = value.id;
      rows[index]['invoice_item_name'] = value.name || '';
    } else {
      rows[index][field] = value;
    }
    this.setState({ independentInvoiceItem: rows });
  };
  addInvoiceItemRow = () => {
    this.setState((prevState) => ({
      independentInvoiceItem: [
        ...prevState.independentInvoiceItem,
        { reference_id: '', invoice_item_name: '', description: '' }
      ]
    }));
  };
  removeInvoiceItemRow = (index) => {
    const invoiceItem = [...this.state.independentInvoiceItem];
    invoiceItem.splice(index, 1);
    this.setState({ independentInvoiceItem: invoiceItem });
  };  

  updateRemark = (key) => (value) => {
    this.setState({ [key]: value });
    this.props.updateGenInvoice(key, value);
  }
  render() {
    const { invoiceList, techConstants, invoicePagination, ctrShortInfo, genInvoice, invoiceWidget, invoiceLoader, invStrLoader, contractInfo } = this.props;
    const filterMenu = {
      'Invoice Type': {
        'inputType': 'dropdown',
        'keyParam': 'invoice_type',
        'placeholder': 'Select Invoice Type',
        'options': [{ label: 'Reserve Invoice', value: '1' }, { label: 'Rental Invoice', value: '2' }, { label: 'Ad Hoc Invoice', value: '9' }, { label: 'Penalty Invoice', value: '3' }, { label: 'Debit Note Invoice', value: '4' }, { label: 'Credit Note Invoice', value: '5' }, { label: 'Security Deposit Invoice', value: '6' },...((gaTelesisInstance||testLessor) ? [{label: 'Management Fee Invoice', value: '10'}] : [])],
        'labelKey': 'label',
        'valueKey': 'name',
      },
      'Invoice Number': {
        'inputType': 'text',
        'keyParam': 'invoice_number'
      },
      'Invoice Due Date': {
        'inputType': 'date',
        'keyParam': 'dueDate'
      },
      'Invoice Date': {
        'inputType': 'date',
        'keyParam': 'transactionDate'
      },
      'Invoice Overdue by Days': {
        'inputType': 'number',
        'keyParam': 'overdue_days'
      },
      'Invoice Status': {
        'inputType': 'dropdown',
        'keyParam': 'status',
        'placeholder': 'Select Status',
        'options':  [{ label: 'Draft', value: '1' }, { label: 'Sent', value: '2' }, { label: 'Paid', value: '3' }, { label: 'Cancelled', value: '4' }, { label: 'Partially Paid', value: '5' },...(jetStreamInstance ? [{ label: 'Updated', value: '7' }] : []),...(titanInstance ? [{ label: 'Approved', value: '6' }] : []),],
        'labelKey': 'label',
        'valueKey': 'name',
      }
    };

    var bank_details = []
    if (genInvoice.bank_details) {
      genInvoice.bank_details.map(item => {
        bank_details.push({ id: item.id, name: ( genInvoice.invoiceType==='10' ? item?.lessor?.name + ' - ' : '' )+item.name + ' (' + item.account_number + ')' })
      })
    }

    const party_list = []
    if (this.state.partyList.length > 0) {
      this.state.partyList.map(item => {
        party_list.push({ id: item.id, name: item.name, is_default:item?.is_default })
      })
    }
        
    const servicer_list = []
    if (this.state.servicerList.length > 0) {
      this.state.servicerList.map(item => {
        servicer_list.push({ id: item.id, name: item.name })
      })
    }

    const selectedBank = genInvoice.dates?.find( (d) => d.value === genInvoice.selectedDate );
    const selectedBankId = selectedBank?.bank_id;    
    console.log('genInvoice',genInvoice);
    
    return (
      <div className="contract-container">
        <div className="mr-rate-wrapper invoice-wrapper" style={{ marginLeft: '60px' }}>
          <Header type="brief" headingText="Lease Management" params={this.props.params} changeMsn={this.changeMsn} exportContract={this.props.exportContract} />
          <ContractSideBar application="Invoice List" type="brief" params={this.props.params} />
          <div>
            {
             this.state.isLoading || invStrLoader || invoiceLoader || this?.props?.contractSummaryLoader? <ListLoader /> :null
            } 
            <Row className="invoice-cards flex-not-centered">
              <WidgetCard md="4" className="padding-right-0 padding-left-xs-0">
                <WidgetTitle className="para">Total Paid Invoices</WidgetTitle>
                <Row>
                  <Col md="6">
                    <h6>Reserve Invoice</h6>
                    <p>
                      {
                        invoiceWidget.mr_total ?
                          <NumericLabel params={showCurrencyFormat()}>
                            {invoiceWidget.mr_total}
                          </NumericLabel> : '--'
                      }

                      <span style={{ opacity: "0.5" }} className="as-of-date">
                        As of {
                          invoiceWidget.mr_detail_as_of_date ?
                            moment(invoiceWidget.mr_detail_as_of_date).format(displayDateFormat) : 'date --'
                        }
                      </span>
                    </p>
                  </Col>
                  <Col md="6">
                    <h6>Monthly Rentals</h6>
                    <p>
                      {invoiceWidget.rental_total_new ?
                        invoiceWidget.rental_total_new.length ?
                          invoiceWidget.rental_total_new.map((invoice, index) =>
                            <div>
                              <NumericLabel params={showCurrencyFormat(invoice.currency)}>
                                {invoice.total_amount}
                              </NumericLabel></div>) : '--' : '--'
                      }

                      <span style={{ opacity: "0.5" }} className="as-of-date">
                        As of {
                          invoiceWidget.rental_detail_as_of_date ?
                            moment(invoiceWidget.rental_detail_as_of_date).format(displayDateFormat) : 'date --'
                        }
                      </span>
                    </p>
                  </Col>
                </Row>
              </WidgetCard>
              <WidgetCard md="4" className="padding-right-0 padding-left-xs-0">
                <WidgetTitle className="para invoice-space-block">Pending Reserve Invoices</WidgetTitle>
                <Row>
                  <Col md="6">
                    <h6 className="caption-ui">
                      Not Yet Due
                      <span
                        style={{ position: 'absolute', top: '-1px', left: "83px", fontSize: '15px', color: '#fff' }}
                      >
                        <i className="fa fa-info-circle" id='notYetDueMaintanence' aria-hidden="true"></i>
                        <UncontrolledTooltip placement="right" target="notYetDueMaintanence">
                          Payments pending to be received but not past due date
                        </UncontrolledTooltip>
                      </span>
                    </h6>
                    <p className="space-block wrapword">
                      {
                        invoiceWidget.mr_not_due ?
                          <NumericLabel params={showCurrencyFormat()}>
                            {invoiceWidget.mr_not_due}
                          </NumericLabel> : '--'
                      }
                    </p>
                  </Col>
                  <Col md="6" className="text-right">
                    <h6 className="caption-ui">Overdue</h6>
                    <p className="space-block wrapword">
                      {
                        invoiceWidget.mr_overdue ?
                          <NumericLabel params={showCurrencyFormat()}>
                            {invoiceWidget.mr_overdue}
                          </NumericLabel> : '--'
                      }
                    </p>
                  </Col>
                </Row>
                <div className={(invoiceWidget.mr_not_due == 0 && invoiceWidget.mr_overdue == 0) ? 'green' : ''}>
                  <Progress value={Math.round(Math.round(invoiceWidget.mr_not_due / (invoiceWidget.mr_not_due + invoiceWidget.mr_overdue) * 100))} />
                </div>
              </WidgetCard>
              <WidgetCard md="4" className="padding-right-0 padding-left-xs-0">
                <WidgetTitle className="para invoice-space-block">Pending Rental Invoices</WidgetTitle>
                <Row>

                  <Col md="6">
                    <h6 className="caption-ui">Not Yet Due
                      <span
                        style={{ position: 'absolute', top: '-1px', left: "83px", fontSize: '15px', color: '#fff' }}
                      >
                        <i className="fa fa-info-circle" id='notYetDueRentals' aria-hidden="true"></i>
                        <Tooltip placement="right" isOpen={this.state.tooltipOpen} target="notYetDueRentals" toggle={this.toggleTip}>
                          Payments pending to be received but not past due date
                        </Tooltip>
                      </span>
                    </h6>
                    <p className="space-block wrapword">
                      {invoiceWidget.rental_not_due_new ?
                        invoiceWidget.rental_not_due_new.length ?
                          invoiceWidget.rental_not_due_new.map((invoice, index) =>
                            <div>
                              <NumericLabel params={showCurrencyFormat(invoice.currency)}>
                                {invoice.total_amount}
                              </NumericLabel></div>) : '--' : '--'
                      }
                    </p>
                  </Col>
                  <Col md="6" className="text-right">
                    <h6 className="caption-ui">Overdue</h6>
                    <p className="space-block wrapword">
                      {invoiceWidget.rental_overdue_new ?
                        invoiceWidget.rental_overdue_new.length ?
                          invoiceWidget.rental_overdue_new.map((invoice, index) =>
                            <div>
                              <NumericLabel params={showCurrencyFormat(invoice.currency)}>
                                {invoice.total_amount}
                              </NumericLabel></div>) : '--' : '--'
                      }
                    </p>
                  </Col>
                </Row>
                <div className={(invoiceWidget.rental_not_due == 0 && invoiceWidget.rental_overdue == 0) ? 'green' : ''}>
                  <Progress value={Math.round(Math.round(invoiceWidget.rental_not_due / (invoiceWidget.rental_not_due + invoiceWidget.rental_overdue) * 100))} />

                </div>
              </WidgetCard>
            </Row>
            <div className="contract-invoice-list">
              <div className="mobile-asset-list">
                <div className="generate-invoice flex-centered">
                  {checkPermission('contracts', 'invoices', 'C') && contractInfo?.hdlineInfo?.archived_asset == false ?
                    <button onClick={() => this.props.updateGenInvoice('flag', true)} className="btn primary-btn">Generate Invoice</button> : null
                  }
                  <div className="download-block" style={{ paddingRight: '15px' }}>
                    {checkPermission('contracts', 'invoices', 'EXP') && invoiceList?.length ?
                      <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle caret size="sm">
                          <span><img width="12" src={exportIcon} alt="export" /> Export </span>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => this.props.exportInvoice(ctrShortInfo, 'pdf', removeEmptyKey(this.getQueryStrfn(this.state.appliedFilter)))}><img src={imgStoragePath + "pdf_icon.png"} alt="img" />PDF</DropdownItem>
                          <DropdownItem onClick={() => this.props.exportInvoice(ctrShortInfo, 'xls', removeEmptyKey(this.getQueryStrfn(this.state.appliedFilter)))} ><img src={imgStoragePath + "excel_icon.png"} alt="img" />Excel</DropdownItem>
                        </DropdownMenu>
                      </ButtonDropdown>
                      : null
                    }
                  </div>
                </div>
              </div>
              <div className="mobile-asset-list">
                <div className="asset-list-filter-sort">
                  <FilterBar appliedFilter={this.state.appliedFilter} clearFilterValue={this.clearFilterValue} filterMenu={filterMenu} changeFilterFn={this.changeFilterFn} />
                </div>
                <div className="asset-list-filter-sort">
                  <InvoiceFilter />
                </div>
                {
                  invoiceList.map((invoice, index) =>
                    <InvoiceList
                      contractInfo={contractInfo}
                      updateListInvStatus={this.updateListInvStatus}
                      key={index} params={this.props.params}
                      contract_slug={ctrShortInfo.contract ? this.props.params.contract_slug : ''}
                      invoice={invoice}
                      ctrShortInfo={ctrShortInfo}
                      props={this.props}
                      attachedDocList={this.state.attachedDocList}
                      getInvoiceAttachment={this.getInvoiceAttachment}
                    />)
                }

              </div>
              {
                !invoiceLoader && !invoiceList.length ? null :
                  <div style={{ padding: '0 0 40px 0' }}>
                    <Pagination
                      activePage={this.state.page}
                      itemsCountPerPage={20}
                      totalItemsCount={(invoicePagination && invoicePagination.total) ? invoicePagination.total : 0}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange}
                    />
                  </div>
              }
              {
                !invoiceLoader && !invoiceList.length ?
                  <NoRecordFound description="Get Started by clicking 'Generate Invoice' button above" />
                  : null
              }
            </div>

            <EditSidebar width="550px" right="-550px" title="Generate Invoice" editSideBar={genInvoice.flag} toggleEditSideBar={() => this.props.updateGenInvoice('flag', false)}>
              {
                genInvoice.flag ?
                  <form onSubmit={this.getInvoiceStr}>
                    <div style={{ height: (window.innerHeight - 120) + 'px', overflow: 'auto', marginBottom: '60px' }}>
                      <ContrSelectField
                        label="Invoice Type"
                        placeholder='Select Invoice Type'
                        keyParam="invoiceType"
                        value={genInvoice.invoiceType}
                        options={[{ label: 'Reserve Invoice', value: '1' }, { label: 'Rental Invoice', value: '2' }, { label: 'Ad Hoc Invoice', value: '9' }, { label: 'Penalty Invoice', value: '3' }, { label: 'Debit Note Invoice', value: '4' }, { label: 'Credit Note Invoice', value: '5' }, { label: 'Security Deposit Invoice', value: '6' },...((gaTelesisInstance||testLessor) ? [{ label: 'Management Fee Invoice', value: '10' }] : [])]}
                        updateField={this.updateForm}
                        type="edit"
                        labelKey='label'
                        valueKey='value'
                        md="12"
                        error={this.state.error.invoiceType}
                        updateErrorCode={(key) => this.setState(prev => ({ error: { ...prev.error, [key]: null } }))}                        
                      />
                      {genInvoice.invoiceType === '2' && jetStreamInstance ?
                      <FieldCol md="12">
                        <FieldGroup className="form-group">
                          <span style={{ fontWeight: this.state.rentalInvoiceType.value === 1 ? "600" : "400", color: this.state.rentalInvoiceType.value === 1 ? "#04049e" : "#888", fontFamily: this.state.rentalInvoiceType.value === 1 ? 'Conv_IBMPlexSans-Bold' : 'Conv_IBMPlexSans-Regular'  }}>Advance</span>
                            <Switch
                              checked={this.state.rentalInvoiceType.value === 2}
                              onChange={(e) =>{this.setState({ rentalInvoiceType: e.target.checked ? { value: 2, label: "Arrear" } : { value: 1, label: "Advance" } }) ;this.props.fetchDates(this.props.params.contract_slug, this.props.genInvoice.invoiceType, this.state.rentalInvoiceType.value === 1 ? 2 : 1 , 'rental_invoice_type');}}
                              color="primary"
                              size="small"
                            />
                          <span style={{ fontWeight: this.state.rentalInvoiceType.value === 2 ? "600" : "400", color: this.state.rentalInvoiceType.value === 2 ? "#04049e" : "#888", fontFamily: this.state.rentalInvoiceType.value === 2 ? 'Conv_IBMPlexSans-Bold' : 'Conv_IBMPlexSans-Regular'  }}>Arrear</span>
                        </FieldGroup>
                      </FieldCol>:null}
                      {(titanInstance || gaTelesisInstance) ?<>
                        <ContrSelectField
                          label={"Owner/Trustee"}
                          placeholder={"Select Owner/Trustee"}
                          keyParam="party_id"
                          value={genInvoice.party_id}
                          options={party_list}
                          updateField={this.updateForm}
                          type="edit"
                          labelKey='name'
                          valueKey='id'
                          md="12"
                        />
                        {genInvoice.invoiceType === '10'?<>
                        <ContrSelectField
                          label={"Servicer"}
                          placeholder={"Select Servicer"}
                          keyParam="servicer_id"
                          valReq={true}
                          value={genInvoice.servicer_id}
                          options={servicer_list}
                          updateField={this.updateForm}
                          type="edit"
                          labelKey='name'
                          valueKey='id'
                          md="12"
                          error={this.state.error.servicer_id}
                          updateErrorCode={(key) => this.setState(prev => ({ error: { ...prev.error, [key]: null } }))}
                        />
                        <ContrSelectField
                          label={"Invoiced To"}
                          placeholder={"Select Invoiced To"}
                          keyParam="invoice_to_id"
                          value={genInvoice.invoice_to_id}
                          options={servicer_list}
                          valReq={true}
                          updateField={this.updateForm}
                          type="edit"
                          labelKey='name'
                          valueKey='id'
                          md="12"
                          error={this.state.error.invoice_to_id}
                          updateErrorCode={(key) => this.setState(prev => ({ error: { ...prev.error, [key]: null } }))}
                        />
                        </>:null}
                        </>: null}
                      { genInvoice.invoiceType === '5' ||genInvoice.invoiceType === '4' ?  
                      <div className="form-group" style={{marginLeft:'10px'}}>
                        <FormControl component="fieldset" style={{ marginBottom: '16px' }}>
                          <RadioGroup
                            row
                            value={this.state.isIndependent ? 'true' : 'false'}
                            onChange={(e) => this.setState({ isIndependent: e.target.value === 'true' })}
                          >
                            <FormControlLabel value="false" control={<Radio size="small" color="primary" />} label="Existing" />
                            <FormControlLabel value="true" control={<Radio size="small" color="primary" />} label="Independent" />
                          </RadioGroup>
                        </FormControl>
                      </div>:null}
                      {gaTelesisInstance && genInvoice.invoiceType === '2'?null:
                        ((genInvoice.dates.length > 0 || gaTelesisInstance) && (genInvoice.invoiceType === '1' || genInvoice.invoiceType === '2'|| genInvoice.invoiceType === '10'  || ((genInvoice.invoiceType === '5' ||genInvoice.invoiceType === '4') ? this.state.isIndependent === false : true) )) && (
                          <ContrSelectField
                            label={genInvoice.invoiceType == '1' ? 'Utilization month to be invoiced' : genInvoice.invoiceType == '2' ? 'Rental month to be invoiced' : 'Invoice number'}
                            placeholder={genInvoice.invoiceType == '1' ? 'Select month' : genInvoice.invoiceType == '2' ? 'Select month' : 'Select invoice number'}
                            keyParam="selectedDate"
                            value={genInvoice.selectedDate}
                            options={genInvoice.dates}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='label'
                            valueKey='value'
                            md="12"
                          /> )

                      }
                      {gaTelesisInstance && genInvoice.invoiceType === '2'?
                      <>
                        <ContrSelectField
                            label={ 'Rental start month to be invoiced'}
                            placeholder={'Select month'}
                            keyParam="selectedDate"
                            value={genInvoice.selectedDate}
                            options={genInvoice.dates}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='label'
                            valueKey='value'
                            md="6"
                            />
                            {genInvoice.selectedDate && genInvoice?.prorated_months?.includes(genInvoice.selectedDate)?
                          <Col md={'8'} >
                            <span style={{display:"flex",alignItems:'center', color: "#a0a0a0", fontSize: '13px', marginLeft: '25px', position:'relative', top:'-25px' }}>
                              Selected Start Date: 
                              
                              <span style={{ display: 'inline-block',position:"relative", width:"140px",left:'10px' }}>
                              {genInvoice?.prorated_months.includes(genInvoice.selectedDate)?
                                      <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                        inputVariant="standard"        
                                          format={fieldDateFormat}     
                                          placeholder={fieldDateFormat}
                                          value={ genInvoice.updatedDate &&  genInvoice.updatedDate !== "Invalid date" &&  moment(genInvoice.updatedDate).isValid()  ? moment(genInvoice.updatedDate)  : null}
                                          onChange={(date) => {
                                            if (date && moment(date).isValid()) {
                                              this.updateForm('updatedDate', moment(date).format(backendDateFormat));
                                            } else {
                                              this.updateForm('updatedDate', null, null);
                                            }
                                          }}
                                          minDate={genInvoice.selectedDate ? moment(genInvoice.selectedDate) : undefined}
                                          maxDate={genInvoice.selectedDate ? moment(genInvoice.selectedDate).endOf('month') : undefined}
                                          InputProps={{ readOnly: true,}}
                                          KeyboardButtonProps={{'aria-label': 'change date',}}
                                          showTodayButton={false} 
                                        />
                                      </MuiPickersUtilsProvider>
                                : <h6>{genInvoice.selectedDate ? moment(genInvoice.selectedDate).format(fieldDateFormat):'--'}</h6>}
                              </span>
                            </span>
                          </Col>:null}
                            <ContrSelectField
                            label={ 'Rental end month to be invoiced'}
                            placeholder={'Select month'}
                            keyParam="end_month"
                            disabled={!genInvoice?.prorated_months?.includes(genInvoice.selectedDate)||!genInvoice.selectedDate}
                            value={genInvoice.end_month}
                            options={genInvoice.dates}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='label'
                            valueKey='value'
                            md="6"
                          />
                           {genInvoice.end_month && genInvoice?.prorated_months?.includes(genInvoice.end_month)?
                          <Col md={'8'} >
                            <span style={{display:"flex",alignItems:'center', color: "#a0a0a0", fontSize: '13px', marginLeft: '25px', position:'relative', top:'-25px' }}>
                              Selected End Date: 
                              
                              <span style={{ display: 'inline-block',position:"relative", width:"140px",left:'10px' }}>
                              {genInvoice?.prorated_months.includes(genInvoice.end_month)?
                                      <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                        inputVariant="standard"        
                                          format={fieldDateFormat}     
                                          placeholder={fieldDateFormat}
                                          value={ genInvoice.updatedEndDate &&  genInvoice.updatedEndDate !== "Invalid date" &&  moment(genInvoice.updatedEndDate).isValid()  ? moment(genInvoice.updatedEndDate)  : null}
                                          onChange={(date) => {
                                            if (date && moment(date).isValid()) {
                                              this.updateForm('updatedEndDate', moment(date).format(backendDateFormat));
                                            } else {
                                              this.updateForm('updatedEndDate', null, null);
                                            }
                                          }}
                                          disabled={!genInvoice?.prorated_months.includes(genInvoice.selectedDate)}
                                          minDate={genInvoice.end_month ? moment(genInvoice.end_month) : undefined}
                                          maxDate={genInvoice.end_month ? moment(genInvoice.end_month).endOf('month') : undefined}
                                          InputProps={{ readOnly: true,}}
                                          KeyboardButtonProps={{'aria-label': 'change date',}}
                                          showTodayButton={false} 
                                        />
                                      </MuiPickersUtilsProvider>
                                : <h6>{genInvoice.end_month ? moment(genInvoice.end_month).endOf('month').format(fieldDateFormat):'--'}</h6>}
                              </span>
                            </span>
                          </Col>:null}
                            </>
                          : null
                      }
                      {
                        genInvoice.invoiceType === '6' ?
                          <ContrSelectField
                            label={"Security Deposit Type"}
                            placeholder={"Select Security Deposit"}
                            keyParam="security_deposit_type"
                            value={genInvoice.security_deposit_type}
                            options={techConstants.filter(item => item.type == "security_deposit_type")}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='label'
                            valueKey='value'
                            md="12"
                          /> :
                          null

                      }
                      {
                        genInvoice.invoiceType === '7' ?
                          <ContrSelectField
                            label={"Insurances"}
                            placeholder={"Select Insurance"}
                            keyParam="selectedDate"
                            value={genInvoice.selectedDate}
                            options={genInvoice.insurances}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='type'
                            valueKey='id'
                            md="12"
                          /> :
                          null

                      }
                      {
                        genInvoice.invoiceType === '8' ?
                          <ContrSelectField
                            label={"Insurance Claims"}
                            placeholder={"Select Insurance Claim"}
                            keyParam="selectedDate"
                            value={genInvoice.selectedDate}
                            options={genInvoice.insurance_claim}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='type'
                            valueKey='id'
                            md="12"
                          /> :
                          null

                      }
                      {
                        genInvoice.security_deposit && genInvoice.security_deposit.length ?
                          <ContrSelectField
                            label={"Security Deposit Against ( Amount ) "}
                            placeholder={"Security Deposit Against"}
                            keyParam="selectedDate"
                            value={genInvoice.selectedDate}
                            options={genInvoice.security_deposit}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='security_against'
                            valueKey='id'
                            md="12"
                          /> :
                          null

                      }
                      {
                        (genInvoice.bank_details && genInvoice.bank_details.length) || gaTelesisInstance ?
                          <ContrSelectField
                            label={"Bank"}
                            placeholder={"Select Bank"}
                            keyParam="bank_details_id"
                            value={ bank_details.some(bank => bank.id === selectedBankId) && genInvoice.invoiceType !== '10' ? selectedBankId : genInvoice.bank_details_id }                            
                            options={bank_details}
                            updateField={this.updateForm}
                            type="edit"
                            labelKey='name'
                            valueKey='id'
                            md="12"
                            disabled={(genInvoice.invoiceType === '4' || genInvoice.invoiceType === '5') && !this.state.isIndependent && bank_details.some(bank => bank?.id === selectedBankId)  || ['9','3'].includes(genInvoice.invoiceType) && bank_details?.some(bank => bank?.id === selectedBankId)}
                          /> :
                          null

                      }
                      {titanInstance && (genInvoice.invoiceType === '5' || genInvoice.invoiceType === '4' )?
                      <FieldCol md="12">
                        <FieldGroup className="form-group">
                          <FieldLabel className="label">Remarks</FieldLabel>
                          <FieldTextarea
                            value={this.state.remarks}
                            keyParam="remarks"
                            updateField={this.updateRemark('remarks')}
                          />
                        </FieldGroup>
                      </FieldCol>:null}
                      {genInvoice.invoiceType === '5' || genInvoice.invoiceType === '4' ? (
                        <>
                          {this.state.isIndependent && (
                            <>
                                {/* <ContrDateField
                                  label="Parent Invoice Start Date"
                                  keyParam="start_date"
                                  value={genInvoice.start_date}
                                  updateField={this.updateForm}
                                  type="edit"
                                  md="12"
                                />
                                <ContrDateField
                                  label="Parent Invoice End Date"
                                  keyParam="end_date"
                                  value={genInvoice.end_date}
                                  updateField={this.updateForm}
                                  type="edit"
                                  md="12"
                                /> */}
                              <ContrSelectField
                                label="Account Type"
                                placeholder="Select Account Type"
                                keyParam="parentInvoiceType"
                                value={this.state.parentInvoiceType}
                                options={[ { label: 'Reserve Account', value: '1' }, { label: 'Rental Account', value: '2' }, ]}
                                updateField={(key, value) => { this.setState({ parentInvoiceType: value }); if (value === '1') { this.fetchReserveAccounts(); } }} 
                                type="edit"
                                labelKey="label"
                                valueKey="value"
                                md="12"
                              />
                            </>
                          )}
                          {this.state.parentInvoiceType === '1' && (
                            <div style={{ padding: '0px 10px' ,marginRight:'20px', marginLeft:'34px', marginBottom:'20px'}}>
                              <div className="">
                                <label className="label">Invoice Items</label>
                                <TableContainer component={Paper} style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                  <Table className='mui-table-format' stickyHeader>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell style={{ width: '70%' }}>Reserve Rate</TableCell>
                                        <TableCell style={{ width: '10%' }}></TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {this.state.independentInvoiceItem.map((row, index) => (
                                        <TableRow key={index}>
                                          <TableCell>
                                            <Autocomplete
                                              value={ this.state.reserveRateList.find(opt => opt.id === row.reference_id) || null }
                                              onChange={(e, newValue) => { if (newValue) { this.handleItemChange(index, 'reserve_object', newValue); } }}
                                              options={this.state.reserveRateList.filter((option) => option.id === row.reference_id || !this.state.independentInvoiceItem.some((r, i) => i !== index && r.reference_id === option.id) )}                                              getOptionLabel={(option) => option.name || ''}
                                              getOptionSelected={(option, value) => option.id === value.id}
                                              renderInput={(params) => ( <TextField {...params} size="small" /> )}
                                            />
                                          </TableCell>
                                          <TableCell> <IconButton size="small" onClick={() => this.removeInvoiceItemRow(index)} > <RemoveCircleOutline color='secondary' fontSize="small" /> </IconButton> </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                {this.state.independentInvoiceItem.every(row => row.reference_id) &&
                                  this.state.reserveRateList.filter(opt => !this.state.independentInvoiceItem.some(row => row.reference_id === opt.id)).length > 0 && (
                                    <button type="button" className="btn btn-sm btn-secondary mt-2" onClick={this.addInvoiceItemRow}> + Add Item </button>
                                )} 
                              </div>
                            </div>)}
                        </>) : null}
                      {(gaTelesisInstance || Lessor_test|| testLessor) && genInvoice.invoiceType && !['3','10'].includes(genInvoice.invoiceType) ?
                        <div className="form-group">
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={{ marginLeft: "15px", fontSize: "12px" }}
                                color="primary"
                                size='small'
                                checked={genInvoice.jct_invoice ? genInvoice.jct_invoice : false}
                                onChange={(e) => this.updateForm('jct_invoice', e.target.checked)}
                                value="jct_invoice"
                              />}
                            label={<span style={{ fontSize: "13px", color: "#a0a0a0" }}>Apply JCT</span>} />
                        </div> : null}
                      {gaTelesisInstance && genInvoice?.invoiceType =='3'?
                        <FieldGroup className="form-group" style={{ marginLeft: '16px' }}>
                          <FieldLabel className="label">SOFR %
                          </FieldLabel>
                          <input type="text"
                            value={genInvoice.sofr_percentage || ''}
                            onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? e.target.value > 100 ? e.preventDefault() : this.updateForm('sofr_percentage', e.target.value) : e.preventDefault()}
                            style={{ borderBottom: '1px solid #828282' }}
                          />
                        </FieldGroup> : null}
                      {(gaTelesisInstance || testLessor) && genInvoice?.invoiceType == '10' ? <>
                        <FieldGroup className="form-group" style={{ marginLeft: '16px' }}>
                          <FieldLabel className="label">Management Fee %<sup className="reqStar"> * </sup></FieldLabel>
                          <input type="text"
                            value={genInvoice.management_tax || ''}
                            onChange={(e) => regexConstants.percantageRegExp.test(e.target.value) ? this.updateForm('management_tax', e.target.value) : e.preventDefault()}
                            style={{ borderBottom: '1px solid #828282' }}
                          />
                          <h6  className="error-msg">{this.state.error.management_tax}</h6>
                        </FieldGroup>
                        <FieldGroup className="form-group" style={{ marginLeft: '16px' }}>
                          <FieldLabel className="label">VAT %</FieldLabel>
                          <input type="text"
                            value={genInvoice.vat_tax || ''}
                            onChange={(e) => regexConstants.percantageRegExp.test(e.target.value) ? this.updateForm('vat_tax', e.target.value) : e.preventDefault()}
                            style={{ borderBottom: '1px solid #828282' }}
                          />
                          {/* <h6 className="error-msg">{this.state.error.vat_tax}</h6> */}
                        </FieldGroup> </> : null}
                        { titanInstance && (genInvoice.invoiceType === '5' || genInvoice.invoiceType === '4' ) ? 
                       (genInvoice?.selectedDate && ![1,2].includes(genInvoice?.dates.find(item=> (item?.value == genInvoice?.selectedDate))?.invoice_type)) ? null :
                        <div className="form-group">
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={{ marginLeft: "15px", fontSize: "12px" }}
                                color="primary"
                                size='small'
                                checked={genInvoice.is_offset ? genInvoice.is_offset : false}
                                onChange={(e) => this.updateForm('is_offset', e.target.checked)}
                                value="is_offset"
                              />}
                            label={<span style={{ fontSize: "13px", color: "#a0a0a0" }}>Mark as Offset Invoice</span>} />
                        </div>
                        :null
                      }
                      <div className="form-group">
                        <button  className="btn-primary add-new">
                          {invStrLoader ? 'Processing...' : 'Generate Invoice'}
                        </button>
                        <span onClick={() => {this.props.updateGenInvoice('flag', false);this.setState({error:''}); this.setState({rentalInvoiceType:{ value: 1, label: "Advance" }})}} style={{ padding: '0 16px', cursor: 'pointer', textTransform: 'uppercase', color: '#3f51b5' }}>Cancel</span>
                      </div>
                    </div>
                  </form> : null
              }

            </EditSidebar>
          </div>
        </div>
        {this.state?.showExcessModal?.modal ?
          <ExcessAmountModal
          onClose={()=>this.setState({showExcessModal:{modal:false}})}
          params={this.props.params}
          data={this.state?.showExcessModal?.data}
          onProceed={this.onProceed}
          />
          :null}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  contractSummaryLoader: state.sharedReducers.contractSummaryLoader,
  invoiceList: state.InvoiceReducer.invoiceList,
  invoicePagination: state.InvoiceReducer.invoicePagination,
  genInvoice: state.InvoiceReducer.genInvoice,
  invoiceWidget: state.InvoiceReducer.invoiceWidget,
  ctrShortInfo: state.ContractListReducer.ctrShortInfo,
  invoiceLoader: state.InvoiceReducer.invoiceLoader,
  invStrLoader: state.InvoiceReducer.invStrLoader,
  techConstants: state.sharedReducers.techConstants,
  assetViewId: state.userAssetReducer.assetViewId,
  contractInfo: state.ContrHdlineReducer.contrHdlineInfo,

})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchContractInfo: () => dispatch(contrHdlineInfoAc(ownProps.params)),
    fetchAssetInfo: () => dispatch(InvoiceAssetViewAc(ownProps.params)),
    exportContract: (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
    fetchInvList: (contract_slug, queryFilter) => dispatch(invoiceListAc(contract_slug, queryFilter)),
    fetchDates: (contract_slug, value, security_deposit_type, type) => dispatch(invoiceDatesAc(contract_slug, value, security_deposit_type, type)),
    genInvoiceStr: (contract_slug, data, assetViewId, isProRatedMonth) => dispatch(genInvoiceStrAc(ownProps.params, contract_slug, data, assetViewId,isProRatedMonth)),
    exportInvoice: (contract, fileType, queryFilter) => dispatch(exportContractCashflowAc(ownProps, contract, fileType, queryFilter)),
    updateInvStatus: (data, contractSlug, invoiceId, type) => dispatch(changeInvoiceStatusAc(ownProps.params, data, contractSlug, invoiceId, type)),
    updateGenInvoice: (type, value) => dispatch({
      type: GEN_INVOICE,
      payload: { type, value }
    }),
    fetchTechConstant: (constantTypes) => dispatch(sGlobalConstantAc(constantTypes)),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(Invoice, ['contracts', 'invoices', 'R'])));
